var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "worksHeader" },
    [
      _c("header", { staticClass: "header", attrs: { id: "header" } }, [
        _c(
          "nav",
          { staticClass: "navbar navbar-default navbar-fixed-top thin" },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "navbar-header" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "navbar-brand",
                    on: {
                      click: function ($event) {
                        return _vm.$router.push("/home")
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.themeData.logo ? _vm.themeData.logo : _vm.logo,
                        alt: "Law",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collapse navbar-collapse",
                  attrs: { id: "header_collapse" },
                },
                [
                  _c("ul", { staticClass: "nav navbar-nav navbar-right" }, [
                    _c("li", { staticClass: "current" }, [
                      _c(
                        "a",
                        {
                          class: _vm.$route.name == "home" ? "active" : "",
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/home")
                            },
                          },
                        },
                        [
                          _c("svg-icon", { attrs: { "icon-class": "home" } }),
                          _vm._v("首页"),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          class: _vm.$route.name == "works" ? "active" : "",
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/works")
                            },
                          },
                        },
                        [
                          _c("svg-icon", { attrs: { "icon-class": "find" } }),
                          _vm._v("发现作品"),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          class: _vm.$route.name == "sh" ? "active" : "",
                          on: { click: _vm.goBlock },
                        },
                        [
                          _c("svg-icon", { attrs: { "icon-class": "block" } }),
                          _vm._v("图形化创作"),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          class: _vm.$route.name == "py" ? "active" : "",
                          on: { click: _vm.goPython },
                        },
                        [
                          _c("svg-icon", { attrs: { "icon-class": "python" } }),
                          _vm._v("Python创作"),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          class: _vm.$route.name == "match" ? "active" : "",
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/match")
                            },
                          },
                        },
                        [
                          _c("svg-icon", {
                            attrs: { "icon-class": "competition" },
                          }),
                          _vm._v("竞赛"),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.hostName ==
                    `roborobo.${_vm.institutionConfig.baseDomainName}`
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              class:
                                _vm.$route.name == "codeActivity"
                                  ? "active"
                                  : "",
                              on: { click: _vm.goPlayCode },
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "playCode" },
                              }),
                              _vm._v("玩转编程日"),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hostName ==
                    `kexie.${_vm.institutionConfig.baseDomainName}`
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              class:
                                _vm.$route.name == "lesson" ? "active" : "",
                              on: {
                                click: function ($event) {
                                  return _vm.gotoRoboClass()
                                },
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "lesson" },
                              }),
                              _vm._v("课程"),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          class:
                            _vm.$route.name == "personhome" ? "active" : "",
                          on: { click: _vm.goPersonHome },
                        },
                        [
                          _c("svg-icon", { attrs: { "icon-class": "my" } }),
                          _vm._v("我"),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.hostName !=
                      `roborobo.${_vm.institutionConfig.baseDomainName}` &&
                    _vm.showDownload
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              class:
                                _vm.$route.name == "download" ? "active" : "",
                              on: {
                                click: function ($event) {
                                  return _vm.$router.push("/download")
                                },
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "download" },
                              }),
                              _vm._v("软件下载"),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("li", [
                      _vm.loginBtnShow
                        ? _c("a", { on: { click: _vm.loginShow } }, [
                            _vm._v("登录 / 注册"),
                          ])
                        : _c(
                            "div",
                            { staticClass: "userIcon" },
                            [
                              _c(
                                "el-dropdown",
                                { attrs: { trigger: "click" } },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.userInfo.avatar
                                        ? `http://static.${_vm.institutionConfig.baseDomainName}/noavatar.png`
                                        : `http://static.${_vm.institutionConfig.baseDomainName}/noavatar.png`,
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      staticClass: "headerComponent",
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.changePassword.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-setting",
                                          }),
                                          _vm._v("修改密码"),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: { divided: "" },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.logout.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-warning-outline",
                                          }),
                                          _vm._v("退出登录"),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                    ]),
                    _vm._v(" "),
                    _vm.isBtnShow
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: `https://${_vm.hostName}/psp` } },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "system" },
                              }),
                              _vm._v("后台管理系统"),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("Login"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "navbar-toggle collapsed",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#header_collapse",
          "aria-expanded": "false",
        },
      },
      [
        _c("span", { staticClass: "sr-only" }, [_vm._v("Toggle navigation")]),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar" }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/header.vue?vue&type=template&id=29e8c3c6&scoped=true&
// module id = null
// module chunks = 